import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { BlockListingViewModel } from '../../../../models/block';

@Component
class BlockGridItem extends Vue {

  @Prop({ default: () => { }, type: [Object], required: true })
  source: BlockListingViewModel

  get lblSetting() {
    return require('@/locales/block').default
  }

  get coAddress(): string {
    const addressParts = [this.source.address.line1, this.source.address.city, this.source.address.country]
    return addressParts.join(', ');
  }
  get redirectTo() {
    return {
      path: `/block/${this.source.id}`,
      params: { id: this.source.id }
    }
  }

  mounted () {

  }
}

export default BlockGridItem;



// WEBPACK FOOTER //
// ./src/containers/block/components/block-grid-item/index.ts